import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const WelcomeScreen = ({ onProceed, isSubmitting }) => {
  const [formData, setFormData] = useState({ name: '', email: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email) {
      onProceed(formData);
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full max-w-xl mx-auto flex flex-col pt-12 pb-24 px-4 text-center"
    >
      <div className="mb-12">
        <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6 border border-amber-500/20">
          <SafeIcon icon={FiIcons.FiAward} className="text-3xl text-amber-500" />
        </div>
        <h1 className="text-4xl md:text-5xl font-serif text-white mb-4 tracking-tight">The Commitment Ritual</h1>
        <p className="text-neutral-400 text-lg font-light italic leading-relaxed">
          "A goal without a plan is just a wish." — Antoine de Saint-Exupéry
        </p>

        <div className="mt-8 rounded-xl overflow-hidden border border-neutral-800/80 shadow-2xl">
          <video 
            src="https://cdn1.sharemyimage.com/smi/2026/05/29/CommittmentPromo.mp4" 
            controls 
            poster="https://cdn1.sharemyimage.com/smi/2026/05/29/CommittmentPromo.fr.jpeg"
            className="w-full"
          ></video>
        </div>
      </div>

      <div className="bg-neutral-900/40 border border-neutral-800/80 rounded-2xl p-8 backdrop-blur-sm shadow-2xl">
        <p className="text-neutral-300 mb-8 text-sm leading-relaxed">
          Before we begin the forge, please identify yourself. Your commitment is private, but your journey must be acknowledged.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6 text-left">
          <div className="space-y-2">
            <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 font-bold ml-1">First Name</label>
            <input 
              required
              type="text"
              placeholder="e.g., Alexander"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full bg-neutral-950 border border-neutral-800 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-amber-500/50 transition-all placeholder:text-neutral-700"
            />
          </div>

          <div className="space-y-2">
            <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 font-bold ml-1">Email Address</label>
            <input 
              required
              type="email"
              placeholder="e.g., alex@manifest.com"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full bg-neutral-950 border border-neutral-800 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-amber-500/50 transition-all placeholder:text-neutral-700"
            />
          </div>

          <button 
            type="submit"
            disabled={!formData.name || !formData.email || isSubmitting}
            className="w-full py-4 bg-amber-600 hover:bg-amber-500 text-white font-bold rounded-xl transition-all shadow-lg shadow-amber-900/20 disabled:opacity-50 flex items-center justify-center gap-3"
          >
            {isSubmitting ? (
              <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <>BEGIN THE RITUAL <SafeIcon icon={FiIcons.FiArrowRight} /></>
            )}
          </button>
        </form>
      </div>
    </motion.div>
  );
};

export default WelcomeScreen;